module.exports = __webpack_public_path__ + "static/media/NewFilter.6658fe8d.svg";